import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-air-viewer',
  templateUrl: './air-viewer.component.html',
  styleUrls: ['./air-viewer.component.scss']
})
export class AirViewerComponent implements OnInit {

  @Input() iframeSrcURL;
  @Input() vendorId;
  @Input() jwtToken;

  constructor() {
    this.setCookie('TDS-IRIS-Client', 'ETS', 180, '');
  }

  private setCookie(name: string, value: string, expireDays: number, path: string = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cPath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cPath}; SameSite=None; Secure`;
  }

  ngOnInit() {
    (window as any).DATA.frameId = '0extrnlresponseIFrame';
    (window as any).DATA.token = this.jwtToken;
    (window as any).DATA.vendorId = this.vendorId;
  }

}
